const radii = {
  none: "0rem",
  xs: "4px",
  sm: "8px",
  md: "12px",
  lg: "16px",
  xl: "20px",
  "2xl": "28px",
  "3xl": "36px",
  full: "999px"
};

export { radii as default };
